import { createSlice } from '@reduxjs/toolkit';
import { internalTransferAsyncActions } from 'src/Pages/Products/modules/ProductTransfer/modules/TransferSection/modules/modals/InternalTransferModal/services/asyncActions';
import { Nullable } from 'src/Types';
import { UserWarehouseUnitWithPostingsModel } from 'src/Models/Warehouse/UserWarehouseUnitWithPostingsModel';
import { UserWarehousePostingBatchModel } from 'src/Models/Warehouse/UserWarehousePostingBatchModel';

export type InternalTransferState = {
  unitInfo: Nullable<UserWarehouseUnitWithPostingsModel>;
  batchInfo: Nullable<UserWarehousePostingBatchModel>;
};

export const initialState: InternalTransferState = {
  unitInfo: null,
  batchInfo: null,
};

export const { actions: internalTransferActions, reducer: internalTransferReducer } = createSlice({
  name: 'internal-transfer',
  initialState,
  reducers: {
    clean: (state) => {
      state.batchInfo = null;
      state.unitInfo = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(internalTransferAsyncActions.scanBarcode.fulfilled, (state, action) => {
        state.unitInfo = action.payload.transferState.unitInfo;
        state.batchInfo = action.payload.transferState.batchInfo;
      })
      .addCase(internalTransferAsyncActions.getBatch.fulfilled, (state, action) => {
        state.unitInfo = action.payload.transferState.unitInfo;
        state.batchInfo = action.payload.transferState.batchInfo;
      })
      .addCase(internalTransferAsyncActions.createBatch.fulfilled, (state, action) => {
        state.batchInfo = {
          state: action.payload.state,
          id: action.payload.batchId,
          postings: [],
        };
      })

      .addCase(internalTransferAsyncActions.setBatchState.fulfilled, (state, action) => {
        if (state.batchInfo) {
          state.batchInfo.state = action.payload.newState;
        }
      });
  },
});
